/* eslint-disable spire/export-chain */
import { GetCurrentCountriesApiParameter } from "@NA/Services/WebsiteService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadCountries from "@NA/Store/Data/Countries/Handlers/LoadCountries";

export const loadCurrentCountriesParameter: GetCurrentCountriesApiParameter = { expand: ["states"], languageId: "" };

const loadCurrentCountries = (state: ApplicationState) => loadCountries({...loadCurrentCountriesParameter, languageId: state.context.session.language?.id});
export default loadCurrentCountries;
